/* Neosyntis theme - vanilla JS helpers + animations */

(function () {
  'use strict';

  // ============================================================
  // Quantity steppers (product page)
  // ============================================================
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var dir = btn.getAttribute('data-qty');
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val = dir === '+' ? val + 1 : Math.max(1, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ============================================================
  // Koszyk: zmiana ilosci i usuwanie pozycji bez przeladowania
  // ============================================================
  // Stepper +/- zmienial tylko wartosc pola, a koszyk przeliczal sie dopiero
  // po recznym „Aktualizuj koszyk". Klient widzial stara sume i myslal, ze
  // sklep nie zareagowal. Teraz kazda zmiana ilosci idzie do /cart/change.js,
  // a odpowiedz niesie swiezo wyrenderowana sekcje koszyka (parametr
  // `sections`), ktora podmieniamy w miejscu. Bez reloadu, bez skoku strony.
  (function () {
    var SECTION_ID = 'main'; // klucz sekcji z templates/cart.json
    var timer = null;
    var seq = 0;

    function cartRoot() { return document.querySelector('.cart'); }

    function swapSection(html) {
      var wrap = document.getElementById('shopify-section-' + SECTION_ID);
      if (!wrap || !html) { window.location.reload(); return; }
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.firstElementChild;
      if (!fresh) { window.location.reload(); return; }
      wrap.replaceWith(fresh);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }

    function send(payload) {
      var my = ++seq;
      var root = cartRoot();
      if (root) root.classList.add('is-updating');
      payload.sections = SECTION_ID;
      payload.sections_url = window.shopUrls.cart;
      return fetch(window.shopUrls.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (my !== seq) return; // nadjechala nowsza odpowiedz
          if (data && data.sections && data.sections[SECTION_ID]) {
            swapSection(data.sections[SECTION_ID]);
          } else {
            window.location.reload();
          }
        })
        .catch(function () { window.location.reload(); });
    }

    // Zmiana ilosci: stepper wysyla `change`, pole tez po wpisaniu recznym.
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches || !input.matches('.cart input[name^="updates["]')) return;
      var m = input.name.match(/^updates\[(.+)\]$/);
      if (!m) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      clearTimeout(timer);
      timer = setTimeout(function () { send({ id: m[1], quantity: qty }); }, 250);
    });

    // Usuniecie pozycji.
    document.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove-line]');
      if (!rm) return;
      e.preventDefault();
      clearTimeout(timer);
      send({ line: Number(rm.getAttribute('data-remove-line')), quantity: 0 });
    });
  })();

  // ============================================================
  // Scanline overlay - subtle Matrix vibe
  // ============================================================
  document.documentElement.classList.add('scanlines');
  document.documentElement.classList.add('js');

  // ============================================================
  // Capsule float (JS-driven - bypasses OS prefers-reduced-motion
  // which Chrome on Windows forcefully applies to CSS animations)
  // ============================================================
  function startCapsuleFloat() {
    var capsules = document.querySelectorAll('.capsule');
    if (!capsules.length) return;

    // Compute each capsule's base rotation from inline --rot
    var instances = Array.prototype.map.call(capsules, function (el, i) {
      var rotVar = el.style.getPropertyValue('--rot') || '0deg';
      var rotDeg = parseFloat(rotVar);
      // Random-ish phase per capsule for varied movement
      return {
        el: el,
        baseRot: rotDeg,
        phase: i * 1.7, // staggered phase
        durX: 4500 + (i * 700) % 2000,
        durY: 5200 + (i * 1100) % 1800,
        durRot: 6000 + (i * 900) % 1700,
        ampX: 18 + (i % 3) * 4,
        ampY: 26 + (i % 4) * 6,
        ampRot: 10 + (i % 3) * 4
      };
    });

    // Disable CSS animation since JS takes over
    instances.forEach(function (inst) {
      inst.el.style.animation = 'none';
    });

    var startTime = performance.now();
    function frame(now) {
      var t = now - startTime;
      for (var i = 0; i < instances.length; i++) {
        var inst = instances[i];
        var phase = inst.phase * 1000;
        var x = Math.sin((t + phase) / inst.durX * Math.PI * 2) * inst.ampX;
        var y = Math.cos((t + phase * 1.3) / inst.durY * Math.PI * 2) * inst.ampY - inst.ampY * 0.4; // bias upward
        var rotDelta = Math.sin((t + phase * 0.7) / inst.durRot * Math.PI * 2) * inst.ampRot;
        // Mouse parallax - read --mx/--my CSS vars + data-parallax-depth attr (set by setupHeroWow)
        var depth = parseFloat(inst.el.getAttribute('data-parallax-depth')) || 0;
        var pMx = parseFloat(inst.el.style.getPropertyValue('--mx')) || 0;
        var pMy = parseFloat(inst.el.style.getPropertyValue('--my')) || 0;
        var parallaxX = pMx * depth;
        var parallaxY = pMy * depth;
        inst.el.style.transform =
          'translate(' + (x + parallaxX).toFixed(2) + 'px,' + (y + parallaxY).toFixed(2) + 'px) rotate(' + (inst.baseRot + rotDelta).toFixed(2) + 'deg)';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  // ============================================================
  // Mobile nav toggle (hamburger menu) - direct + delegated for robustness
  // ============================================================
  function toggleNav(force) {
    var open = typeof force === 'boolean' ? force : !document.body.classList.contains('nav-open');
    document.body.classList.toggle('nav-open', open);
    var mobileNav = document.querySelector('.mobile-nav');
    if (mobileNav) mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
    var btn = document.querySelector('[data-nav-toggle]');
    if (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Zamknij menu' : 'Otwórz menu');
    }
  }
  function bindBurger() {
    var burger = document.querySelector('[data-nav-toggle]');
    if (burger && !burger.dataset.bound) {
      burger.dataset.bound = '1';
      burger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleNav();
      });
      // Touch fallback for iOS Safari
      burger.addEventListener('touchend', function (e) {
        e.preventDefault();
        toggleNav();
      }, { passive: false });
    }
  }
  bindBurger();
  // Also delegated handler - works for nav links and any future re-renders
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nav-toggle]');
    if (btn) {
      // Already handled by direct binding when possible - but ensures delegation too
      if (!btn.dataset.bound) {
        e.preventDefault();
        toggleNav();
      }
      return;
    }
    // Close drawer when a nav link inside it is clicked (mobile-nav or fallback site-nav)
    if (document.body.classList.contains('nav-open')) {
      var link = e.target.closest('.mobile-nav a, .site-nav a');
      if (link) { toggleNav(false); }
    }
  });
  // Close drawer on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('nav-open')) {
      toggleNav(false);
    }
  });

  // ============================================================
  // Back to top floating button
  // ============================================================
  (function setupBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    var threshold = 480; // px scrolled before button appears
    var ticking = false;

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y > threshold) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        window.scrollTo(0, 0);
      }
    });
  })();

  // ============================================================
  // Scroll-reveal - 13g.fr / Webflow IX2 inspired
  // Adds .in-view to .reveal, .reveal-h, .reveal-img, .stagger
  // when ~12% of the element enters the viewport.
  // ============================================================
  function setupReveal() {
    var targets = document.querySelectorAll('.reveal, .reveal-h, .reveal-img, .stagger');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('in-view'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) { io.observe(el); });
  }

  // ============================================================
  // Counter animation - numbers count up when in view
  // Triggers on elements with [data-counter] attribute (number final value)
  // or on <strong> inside .review-strip / .mission__stat (auto-parses)
  // ============================================================
  function setupCounter() {
    // Targets: data-counter attribute (preferred, explicit), plus legacy review-strip/mission auto-parsing
    var dataCounterTargets = document.querySelectorAll('[data-counter]');
    if (dataCounterTargets.length && 'IntersectionObserver' in window) {
      var dataIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var target = parseFloat(el.getAttribute('data-counter')) || 0;
          var suffix = el.getAttribute('data-suffix') || '';
          var hasDec = target % 1 !== 0;
          var dur = 1800;
          var start = performance.now();
          function step(now) {
            var t = Math.min(1, (now - start) / dur);
            var eased = 1 - Math.pow(1 - t, 3);
            var val = target * eased;
            var display = hasDec
              ? val.toFixed(1).replace('.', ',')
              : Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            el.textContent = display + suffix;
            if (t < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
          dataIo.unobserve(el);
        });
      }, { threshold: 0.3 });
      dataCounterTargets.forEach(function (el) { dataIo.observe(el); });
    }

    var targets = document.querySelectorAll('.review-strip strong, .mission__stat strong');
    if (!targets.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var raw = el.textContent.trim();
        // Parse number from "4.9 / 5", "50 000+", "12 lat", etc.
        var match = raw.match(/[\d\s,.]+/);
        if (!match) { io.unobserve(el); return; }
        var numStr = match[0].replace(/\s/g, '').replace(',', '.');
        var finalNum = parseFloat(numStr);
        if (isNaN(finalNum)) { io.unobserve(el); return; }
        var hasDecimal = /\./.test(numStr);
        var suffix = raw.slice(raw.indexOf(match[0]) + match[0].length);
        var prefix = raw.slice(0, raw.indexOf(match[0]));

        var duration = 1400;
        var start = performance.now();

        function formatNumber(n) {
          if (hasDecimal) return n.toFixed(1).replace('.', ',');
          // Format with thin spaces every 3 digits (Polish style)
          return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }

        function step(now) {
          var t = Math.min(1, (now - start) / duration);
          // ease-out cubic
          var eased = 1 - Math.pow(1 - t, 3);
          var current = finalNum * eased;
          el.textContent = prefix + formatNumber(current) + suffix;
          if (t < 1) requestAnimationFrame(step);
          else el.textContent = raw; // restore exact original
        }

        // Tag for tabular numbers + start
        el.classList.add('counter');
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });

    targets.forEach(function (el) { io.observe(el); });
  }

  // ============================================================
  // Auto-decorate sections with reveal/stagger classes
  // ============================================================
  function decorateSections() {
    // Section heads + lead blocks - use reveal-h (longer rise for headings)
    document.querySelectorAll('.section-head, .science-wrap, .mission, .categories-bio__head, .contact-page__head, .newsletter__head, .footer-head').forEach(function (el) {
      el.classList.add('reveal-h');
    });
    // Hero text inside hero __ subtle reveal on initial paint
    var heroText = document.querySelector('.hero__text');
    if (heroText) heroText.classList.add('reveal-h');
    // Section bodies / standalone paragraphs / images
    document.querySelectorAll('.mission__body, .science__body, .contact-page__body, .about__body, .article__body, .product-detail__body').forEach(function (el) {
      el.classList.add('reveal');
    });
    // Card grids - stagger cascading reveals
    document.querySelectorAll('.product-grid, .why-us__grid, .categories-bio__grid, .experts-grid, .pillars-bio, .mission__stats, .footer__grid, .related-grid').forEach(function (el) {
      el.classList.add('stagger');
    });
    // Section media - image reveal sweep (NOT hero - that has transparent mockups, no mask)
    document.querySelectorAll('.mission__media, .science__media, .product-card__media, .featured-bottle__media').forEach(function (el) {
      el.classList.add('reveal-img');
    });
    // Review strip
    var rs = document.querySelector('.review-strip');
    if (rs) rs.classList.add('stagger');
    // Newsletter wrapper
    var nl = document.querySelector('.newsletter');
    if (nl) nl.classList.add('reveal');
    // Marquee + global blocks
    document.querySelectorAll('.faq-list, .testimonials, .blog-grid, .article-list').forEach(function (el) {
      el.classList.add('stagger');
    });
  }

  // ============================================================
  // Init
  // ============================================================
  // ============================================================
  // 2026 - Scroll progress bar + header shrink
  // ============================================================
  function setupScroll() {
    var bar = document.querySelector('.scroll-progress span');
    var body = document.body;
    var ticking = false;
    function update() {
      var st = window.scrollY || window.pageYOffset;
      var max = (document.documentElement.scrollHeight - window.innerHeight) || 1;
      var pct = Math.min(100, (st / max) * 100);
      if (bar) bar.style.width = pct + '%';
      body.classList.toggle('scrolled', st > 60);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // ============================================================
  // 2026 - Cursor glow in hero
  // ============================================================
  function setupCursorGlow() {
    var heroes = document.querySelectorAll('[data-cursor-glow]');
    heroes.forEach(function (h) {
      h.addEventListener('mousemove', function (e) {
        var rect = h.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        h.style.setProperty('--cx', x + 'px');
        h.style.setProperty('--cy', y + 'px');
      });
    });
  }

  // ============================================================
  // 2026 - Magnetic buttons (subtle tilt toward cursor)
  // ============================================================
  function setupMagnetic() {
    var btns = document.querySelectorAll('[data-magnetic]');
    btns.forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var dx = (e.clientX - cx) * 0.25;
        var dy = (e.clientY - cy) * 0.25;
        btn.style.setProperty('--mx', dx + 'px');
        btn.style.setProperty('--my', dy + 'px');
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.setProperty('--mx', '0px');
        btn.style.setProperty('--my', '0px');
      });
    });
  }

  // ============================================================
  // HERO WOW - title word entrance + glitch + particles + mouse parallax
  // ============================================================
  function setupHeroWow() {
    var hero = document.querySelector('.hero--wow');
    if (!hero) return;

    // -- Title word-split entrance (each word slides up cascade) --
    var title = hero.querySelector('[data-hero-title]');
    if (title && !title.dataset.split) {
      var html = title.innerHTML;
      var tokens = html.match(/(<[^>]+>|[^<\s]+)/g) || [];
      var out = '';
      var wIdx = 0;
      tokens.forEach(function (tok) {
        if (tok.charAt(0) === '<') {
          out += tok;
        } else {
          var delay = (wIdx * 0.11).toFixed(2);
          out += '<span class="word"><span style="animation-delay:' + delay + 's">' + tok + '</span></span> ';
          wIdx++;
        }
      });
      title.innerHTML = out.trim();
      title.dataset.split = '1';
    }

    // -- Floating particles drifting upward --
    var particleWrap = hero.querySelector('[data-hero-particles]');
    if (particleWrap && !particleWrap.children.length) {
      var count = window.innerWidth < 768 ? 8 : 18;
      for (var i = 0; i < count; i++) {
        var p = document.createElement('span');
        var pxv = Math.round(Math.random() * 100);
        var drift = Math.round((Math.random() - 0.5) * 140);
        var delay = (Math.random() * 14).toFixed(2);
        var dur = (10 + Math.random() * 12).toFixed(2);
        var sz = (2 + Math.random() * 4).toFixed(1);
        p.style.left = pxv + '%';
        p.style.width = sz + 'px';
        p.style.height = sz + 'px';
        p.style.setProperty('--drift', drift + 'px');
        p.style.animationDelay = delay + 's';
        p.style.animationDuration = dur + 's';
        particleWrap.appendChild(p);
      }
    }

    // -- Counter animation for hero stats --
    var statCounters = hero.querySelectorAll('.hero__stats [data-counter]');
    statCounters.forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-counter')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      var hasDec = target % 1 !== 0;
      var dur = 1800;
      var start = performance.now();
      function step(now) {
        var t = Math.min(1, (now - start) / dur);
        var eased = 1 - Math.pow(1 - t, 3);
        var val = target * eased;
        var display = hasDec ? val.toFixed(1).replace('.', ',') : Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        el.textContent = display + suffix;
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });

    // -- Mouse parallax on hero (capsules drift toward cursor) --
    var capsules = hero.querySelectorAll('.capsule[data-parallax-depth]');
    if (capsules.length) {
      capsules.forEach(function (el) {
        el.style.setProperty('--depth', el.getAttribute('data-parallax-depth') || 0.05);
      });
      var mx = 0, my = 0, tmx = 0, tmy = 0;
      hero.addEventListener('mousemove', function (e) {
        var rect = hero.getBoundingClientRect();
        tmx = (e.clientX - rect.left - rect.width / 2);
        tmy = (e.clientY - rect.top - rect.height / 2);
      });
      hero.addEventListener('mouseleave', function () {
        tmx = 0; tmy = 0;
      });
      function tick() {
        mx += (tmx - mx) * 0.08;
        my += (tmy - my) * 0.08;
        capsules.forEach(function (el) {
          el.style.setProperty('--mx', mx.toFixed(2));
          el.style.setProperty('--my', my.toFixed(2));
        });
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    // -- Scroll hint fades out once user scrolls --
    var hint = hero.querySelector('.hero__scroll-hint');
    if (hint) {
      var hidden = false;
      window.addEventListener('scroll', function () {
        if (hidden) return;
        if ((window.scrollY || window.pageYOffset) > 80) {
          hint.style.transition = 'opacity .5s ease';
          hint.style.opacity = '0';
          hidden = true;
          setTimeout(function () { hint.remove(); }, 600);
        }
      }, { passive: true });
    }
  }

  // ============================================================
  // Predictive search overlay (header magnifier)
  // ============================================================
  function setupSearch() {
    var panel = document.querySelector('[data-search-panel]');
    if (!panel) return;
    var input = panel.querySelector('[data-search-input]');
    var results = panel.querySelector('[data-search-results]');
    var form = panel.querySelector('.search-overlay__form');
    var toggles = document.querySelectorAll('[data-search-toggle]');
    var endpoint = (window.shopUrls && window.shopUrls.predictiveSearch) || '/search/suggest';
    var HINT = '<p class="search-overlay__hint">Wpisz nazwę peptydu lub suplementu.</p>';

    function open(e) {
      if (e) { e.preventDefault(); }
      document.body.classList.add('search-open');
      panel.setAttribute('aria-hidden', 'false');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() {
      document.body.classList.remove('search-open');
      panel.setAttribute('aria-hidden', 'true');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }

    toggles.forEach(function (t) { t.addEventListener('click', open); });
    panel.querySelectorAll('[data-search-close]').forEach(function (c) {
      c.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('search-open')) { close(); }
    });

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }
    function handleFromUrl(u) {
      try { return decodeURIComponent((u.split('/products/')[1] || '').split('?')[0].split('#')[0]); }
      catch (e) { return ''; }
    }

    function render(products, term) {
      if (!products.length) {
        results.innerHTML = '<p class="search-overlay__hint">Brak wyników dla „' + esc(term) + '”.</p>';
        return;
      }
      var html = '<ul class="search-suggest">';
      products.forEach(function (p) {
        var h = handleFromUrl(p.url);
        var img = (window.nssImg && window.nssImg[h]) || p.image || '';
        var thumb = img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="search-suggest__ph"></span>';
        var isSupp = h.indexOf('nss-') === 0;
        var tag = isSupp ? 'Suplement NSS' : 'Odczynnik RUO';
        html += '<li class="search-suggest__item"><a href="' + esc(p.url) + '">' +
          '<span class="search-suggest__thumb">' + thumb + '</span>' +
          '<span class="search-suggest__meta"><span class="search-suggest__title">' + esc(p.title) + '</span>' +
          '<span class="search-suggest__tag' + (isSupp ? '' : ' search-suggest__tag--ruo') + '">' + tag + '</span></span>' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
          '</a></li>';
      });
      html += '</ul>';
      html += '<a class="search-overlay__all" href="/search?q=' + encodeURIComponent(term) + '&type=product">Pokaż wszystkie wyniki dla „' + esc(term) + '”</a>';
      results.innerHTML = html;
    }

    var timer = null, lastTerm = '';
    function query(term) {
      var url = endpoint + '.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=6';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (term !== lastTerm) { return; }
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, term);
        })
        .catch(function () {
          results.innerHTML = '<p class="search-overlay__hint">Wyszukiwanie chwilowo niedostępne.</p>';
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        var term = input.value.trim();
        lastTerm = term;
        if (timer) { clearTimeout(timer); }
        if (term.length < 2) { results.innerHTML = HINT; return; }
        results.innerHTML = '<p class="search-overlay__hint">Szukam…</p>';
        timer = setTimeout(function () { query(term); }, 180);
      });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        var term = (input && input.value.trim()) || '';
        if (!term) { e.preventDefault(); }
      });
    }
  }

  function init() {
    decorateSections();
    setupReveal();
    setupCounter();
    startCapsuleFloat();
    setupScroll();
    setupCursorGlow();
    setupMagnetic();
    setupHeroWow();
    setupSearch();
    setupFooterAccordion();
    setupHeroMotion();
  }

  // ============================================================
  // Hero motion: cinematic Ken Burns (slow zoom + drift) + mouse
  // parallax on the hero background image. JS-driven so Chrome on
  // Windows (which forces prefers-reduced-motion onto CSS animations)
  // can't kill it. Subtle and GPU-friendly (transform only).
  // ============================================================
  function setupHeroMotion() {
    var bg = document.querySelector('.hero--image .hero__bg-img');
    if (!bg) return;
    var hero = document.querySelector('.hero--image');
    bg.style.willChange = 'transform';
    bg.style.transformOrigin = '60% 50%';

    var tmx = 0, tmy = 0, mx = 0, my = 0;
    if (hero && window.matchMedia('(pointer:fine)').matches) {
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        tmx = (e.clientX - r.left) / r.width - 0.5;
        tmy = (e.clientY - r.top) / r.height - 0.5;
      });
      hero.addEventListener('mouseleave', function () { tmx = 0; tmy = 0; });
    }

    var start = performance.now();
    function frame(now) {
      var t = (now - start) / 1000;
      var zoom = 1.085 + Math.sin(t * 0.16) * 0.028;       // breathe 1.057..1.113
      var driftX = Math.sin(t * 0.12) * 1.3;               // % slow drift
      var driftY = Math.cos(t * 0.10) * 1.0;
      mx += (tmx - mx) * 0.05;                              // eased mouse follow
      my += (tmy - my) * 0.05;
      var px = mx * 2.4, py = my * 1.8;                    // parallax amount
      bg.style.transform = 'scale(' + zoom.toFixed(4) + ') translate(' +
        (driftX + px).toFixed(2) + '%,' + (driftY + py).toFixed(2) + '%)';
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  // ============================================================
  // Footer accordion: collapsed on phone, open columns on desktop.
  // Belt-and-suspenders so the footer never shows headings-only.
  // ============================================================
  function setupFooterAccordion() {
    var cols = document.querySelectorAll('details.site-footer__col');
    if (!cols.length) return;
    function apply() {
      var desktop = window.innerWidth >= 768;
      cols.forEach(function (d) { d.open = desktop; });
    }
    apply();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(apply, 150);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
